import { useCallback } from 'react';
import { toast } from 'sonner';
import { getTotalRecords, getRows } from '@/utils';
import groupService from '@/services/massMailing/groups/groupService';

const toCrmGroupOptions = (rows) =>
    rows.map(group => ({
        label: group.name,
        value: group.id.toString(),
        id: group.id.toString(),
        original: group,
    }));

const useCrmGroupOptions = ({
    defaultPageSize = 20,
    filterContact = false,
} = {}) => {
    const loadOptions = useCallback(
        async ({ search = '', page = 1, pageSize = defaultPageSize } = {}) => {
            try {
                const response = await groupService.getAllCrmGroups({
                    page,
                    pageSize,
                    search,
                });

                const status =
                    typeof response?.status === 'boolean' ? response.status : true;
                if (!status) return { options: [], hasMore: false };

                let rows = getRows(response);
                if (filterContact) rows = rows.filter(group => group.contacts_count > 0);
                const options = toCrmGroupOptions(rows);

                const totalRecords = getTotalRecords(response);
                const hasMore =
                    typeof totalRecords === 'number'
                        ? page * pageSize < totalRecords
                        : options.length === pageSize;

                return { options, hasMore };
            } catch (error) {
                console.error('Error', error);
                toast.error('Failed to fetch groups.', {
                    description: 'Please try again.',
                });
                return { options: [], hasMore: false };
            }
        },
        [defaultPageSize, filterContact]
    );

    return loadOptions;
};

export { useCrmGroupOptions };
